import React, { useState } from "react";
import StartbildNetzplan from "../../components/splashScreen/StartbildNetzplan";

/**
 * Vorschau des Startbilds «Netzplan» unter /startbild-vorschau.
 *
 * Zeigt die Komponente allein, ohne die Anwendung neu zu laden - zum erneuten Abspielen,
 * fuer Standbilder und um sie neben die anderen Werkzeuge zu legen. Die Route steht in
 * App.js in der Liste der Pfade OHNE Startbild, sonst laege das echte ueber der Vorschau.
 */
const StartbildVorschauPage = () => {
    const [lauf, setLauf] = useState(0);
    const [tempo, setTempo] = useState(1);

    const knopf: React.CSSProperties = {
        padding: "6px 14px",
        borderRadius: 4,
        border: "1px solid rgba(255,255,255,.35)",
        background: "rgba(6,18,46,.75)",
        color: "#fff",
        font: "600 12px/1 system-ui, sans-serif",
        letterSpacing: ".08em",
        textTransform: "uppercase",
        cursor: "pointer",
    };

    return (
        <>
            <StartbildNetzplan key={lauf} tempo={tempo} />
            <div style={{ position: "fixed", zIndex: 10000, right: 20, top: 20, display: "flex", gap: 8 }}>
                <button style={knopf} onClick={() => setLauf((n) => n + 1)}>Nochmal</button>
                <button style={knopf} onClick={() => { setTempo((t) => (t === 1 ? 0.35 : 1)); setLauf((n) => n + 1); }}>
                    {tempo === 1 ? "Schnell" : "Normal"}
                </button>
            </div>
        </>
    );
};

export default StartbildVorschauPage;
